import { Deserializable } from '../protocols/deserializable';
import { SubmissionSubStatusIdEnum } from '../enum/shared/submission-sub-status-id-enum';
import { SubmissionReminder, SubmissionStakeholder } from './member-submission';
import { PortalTypeIdEnum } from '../enum/shared/portal-type-id.enum';
import { SubmissionSubStatus } from '../shared/submission-status';

export class SharedSubmission implements Deserializable {
  public id!: number;
  public idPrefix!: string;
  public idSuffix!: string;
  public submissionTypeId!: number;
  public submissionTypeName!: string;
  public name!: string;
  public submittedDate!: string;
  public overdueDate!: string;
  public subStatusId!: SubmissionSubStatusIdEnum | null;
  public subStatus!: SubmissionSubStatus;
  public ownerId!: number | null;
  public owner!: SubmissionStakeholder | null;
  public approverId!: number | null;
  public approver!: SubmissionStakeholder | null;
  public reminder!: SubmissionReminder | null;
  public portalTypeId!: PortalTypeIdEnum;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.subStatus) {
      this.subStatus = Deserialize?.instanceOf(SubmissionSubStatus, this.subStatus);
    }
    if (this.owner) {
      this.owner = Deserialize?.instanceOf(SubmissionStakeholder, this.owner);
    }
    if (this.approver) {
      this.approver = Deserialize?.instanceOf(SubmissionStakeholder, this.approver);
    }
  }
}
